import { render } from "./PopUpSelectClass.vue?vue&type=template&id=6c2f5414&scoped=true"
import script from "./PopUpSelectClass.vue?vue&type=script&lang=js"
export * from "./PopUpSelectClass.vue?vue&type=script&lang=js"

import "./PopUpSelectClass.vue?vue&type=style&index=0&id=6c2f5414&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2f5414"]])

export default __exports__